module.exports = __webpack_public_path__ + "fa52c37c6e3e9d265bef7fa3f88d068f.pdf";